<template>
  <div class="adv">
    <!-- 轮播图 -->
    <div class="banner">
      <div class="img">
        <img src="@/assets/imgs/shouye.jpg" alt="" class="image" />
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 路由导航 -->
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">

          <el-breadcrumb-item :to="{ path: '/newsInfo' }"
            >新闻资讯</el-breadcrumb-item
          >
          <el-breadcrumb-item>媒体报道</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 中部内容 -->
      <div class="teach-content">
        <!-- 版心内容 -->
        <div class="teach-box">
          <!-- 左侧内容 -->
          <div class="teach-left" @scroll="handleScroll($event)">
            <div class="cont-box" v-for="item in List" :key="item.data">
              <p class="title">
                <!-- 全国政协委员卢永琇：加强乡村文化建设 助力乡村振兴战略 -->
                {{ item.title }}
              </p>
              <p class="dat">
                发布日期：{{ item.publishTime }} 浏览次数：{{
                  item.viewCount
                }}次
              </p>
              <div class="artic" v-html="item.content">
                <!-- “乡村振兴，既要塑形，也要铸魂。加强乡村文化建设，才能为乡村振兴注入源源不断的精神动力。”近期，全国政协委员、天津美术馆副馆长卢永琇调研了天津附近乡村文化建设的案例。
                 她发现，个人的文化情结在乡村文化建设中有着重要作用，其带头作用应得到更多鼓励；政府要制定好规划和措施，给予更大的支持力度。
                 因此，卢永琇委员认为：“要立足地方特色，传承弘扬优秀传统文化。” -->
              </div>
              <div class="button" @click="jumpHandler(item.id)">
                了解详情
              </div>
              <div class="xian"></div>
            </div>
            <div class="load" v-if="nextFlag">
              <a-spin v-if="tipMessage != '数据已加载完!'" /><span
                class="load-text"
                >{{ tipMessage }}</span
              >
            </div>
            <div v-if="finalFlag" class="load">
              <span class="load-text">{{ tipMessage }}</span>
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="teach-right">
            <div class="big-title">新闻资讯</div>
            <div class="ge"></div>
            <!-- <div class="tong chang">通知公告</div>
            <div class="tong">馆内动态</div>
            <div class="tong">媒体报道</div> -->
            <el-menu>
              <sideBar
                :list="rigthBoxData"
                :sidebarTitle="sidebarTitle"
              ></sideBar>
            </el-menu>
            <div class="sma-title">服务指南</div>
            <div class="ge"></div>
            <div class="ope">开馆时间</div>
            <div class="right-pub" v-if="info.length" v-html="info[0].value">
              <!-- 友情提示：上饶美术馆周一闭馆（不含节
              假日）疫情期间实行分时预约参观。<br>
               每日可预约时间段如下：9:00-11:00；
                11:00-14:00；14:00-16:00<br>
                地址：上饶市信州区平江道60号<br>
                电话：022—83883300 -->
            </div>
            <div class="adr-tit">美术馆地址</div>
            <!-- 地图 -->
            <div class="right-img">
              <!-- <baidu-map
                @ready="handler"
                style="height:103px"
                :scroll-wheel-zoom="true"
              ></baidu-map> -->
              <baidu-map
                @ready="mapHandle"
                :scroll-wheel-zoom="true"
                style="width:100%;height:103px"
                :key="map.longitude"
              ></baidu-map>
            </div>
            <!-- 按钮 -->
            <div class="order" @click="click">参展预约</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sideBar from "@/components/sideBar";
export default {
  components: {
    sideBar,
  },
  data() {
    return {
      map: {
        longitude: 1,
        latitude: 1,
        address: "",
      },
      page: {
        pageNum: 1,
        pageSize: 5,
      },
      nextFlag: true,
      finalFlag: false,
      tipMessage: "努力加载中...",
      sidebarTitle: "新闻资讯",
      rigthBoxData: [
        {
          name: "通知公告",
          index: "menu1",
          path: "/notice",
          children: [],
        },
        {
          name: "馆内动态",
          index: "menu2",
          path: "/musInfo",
          children: [],
        },
        {
          name: "媒体报道",
          index: "menu3",
          path: "/medInfo",
          children: [],
        },
      ],
      List: [],
      info: {},
    };
  },
  methods: {
    handleScroll(event) {
      console.log(123232323);
      let Scroll = event.target;
      //滚动条到底部的条件
      if (
        Scroll.scrollHeight - (Scroll.scrollTop + Scroll.clientHeight) > 10 &&
        !this.nextFlag &&
        !this.finalFlag
      ) {
        this.nextFlag = true;
        this.page.pageNum++;
        setTimeout(() => {
          this.getList();
        }, 1000);
      }
    },
    getList() {
      var that = this;
      this.$axios
        .get("/frontapi/news/information/list", {
          params: {
            pageNum: this.page.pageNum,
            pageSize: this.page.pageSize,
            type: 2,
          },
        })
        .then(
          function(res) {
            console.log(res);
            that.List = [...that.List, ...res.data.rows];
            if (res.data.rows.length == 0) {
              that.tipMessage = "数据已加载完!";
              that.finalFlag = true;
            }
            that.nextFlag = false;
          },
          function() {
            // console.log("请求失败");
          }
        );
    },
    click() {
      this.$router.replace("/spectatorService/appointment");
    },
    jumpHandler(id) {
      this.$router.push(`/medInfo/details?id=${id}`);
    },
    getServiceGuide() {
      this.$axios({
        method: "get",
        url: "/frontapi/service/information/mapCoordinate",
        data: {},
      }).then((res) => {
        if (res.data.mapCoordinate) {
          var arr = res.data.mapCoordinate.split(",");
          this.map.longitude = parseFloat(arr[0]);
          this.map.latitude = parseFloat(arr[1]);
          this.map.address = res.data.address;
        }
      });
    },
    mapHandle({ BMap, map }) {
      var point = new BMap.Point(this.map.longitude, this.map.latitude);
      map.centerAndZoom(point, 13);
      var icon = new BMap.Icon(
        require("../../assets/imgs/map-position.png"),
        new BMap.Size(74, 84)
      );
      var marker = new BMap.Marker(point, { icon: icon }); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var html = [];
      var opts = {
        width: 250,
        height: 30,
      };

      html.push('<div class="mapTipWindow"> <ul>');
      html.push("<li>" + this.map.address + "</li>");
      html.push("</ul></div>");
      var infowindow = new BMap.InfoWindow(html.join(""), opts);
      marker.addEventListener("click", function() {
        this.openInfoWindow(infowindow);
      });
    },
    // handler({ BMap, map }) {
    //   var point = new BMap.Point(118.003807, 28.48171);
    //   map.centerAndZoom(point, 13);
    //   var marker = new BMap.Marker(point); // 创建标注
    //   map.addOverlay(marker); // 将标注添加到地图中
    //   var circle = new BMap.Circle(point, 6, {
    //     strokeColor: "Red",
    //     strokeWeight: 6,
    //     strokeOpacity: 1,
    //     Color: "Red",
    //     fillColor: "#f03",
    //   });
    //   map.addOverlay(circle);
    // },
    // show() {
    // console.log(shdufhwui);
    // this.$axios({
    // method: "get",
    // url: "/frontapi/news/information/List",
    // data: {},
    //   }).then((res) => {
    // console.log(res);
    //   });
    //  },
  },
  created() {
    this.getServiceGuide();
    // console.log('执行了吗')  浏览器跳装
  },
  mounted() {
    var that = this;
    console.log("this", this);
    this.getList();
    // this.$axios.get("/frontapi/news/information/list?pageNum=1&pageSize=30&type=2").then(
    //   function(res) {
    //     console.log(res);
    //     that.List = res.data.rows;
    //   },
    //   function() {
    //     // console.log("请求失败");
    //   }
    // );
    this.$axios
      .get(
        this.$axios.defaults.baseURL+"/frontapi/service/information/list?name=开馆时间"
      )
      .then(
        function(res) {
          console.log(res);
          that.info = res.data.rows;
          console.log(12345);
          console.log(that.info);
        },
        function() {
          // console.log("请求失败");
        }
      );
  },
};
</script>
<style scoped>
::v-deep .mapTipWindow li {
  font-size: 18px;
}
img {
  font-size: 18px;
}
.nav >>> .el-breadcrumb__inner.is-link {
  font-weight: 500;
  text-decoration: none;
  color: #606266;
}
.right-img >>> .BMap_cpyCtrl {
  display: none;
}
* {
  margin: 0;
  padding: 0;
}
i {
  font-style: normal;
}
.adv {
  width: 100%;
  height: 100%;
  background: #f4f4f4;
  padding-top: 1.111111rem /* 80px -> 1.111111rem */;
}
.banner {
  width: 100%;
  height: auto;
}
.img {
  width: 100%;
  height: auto;
}
.image {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  padding-top: 60px;
}
.nav {
  font-size: 18px;
  width: 1199px;
  height: 18px;
  margin: 0 auto;
  margin-bottom: 40px;
}
.about >>> .nav {
  cursor: pointer;
}
.about >>> .is-link {
  font-weight: 400;
  color: #606266;
  /* cursor: text; */
}
.nav >>> .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 700;
  color: #303133;
  cursor: pointer;
}
.teach-content {
  height: 1124px;
  width: 100%;
  /* background: pink; */
}
.teach-box {
  width: 1199px;
  height: 1064px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.teach-left {
  width: 860px;
  height: 1050px;
  border-radius: 10px;
  background: #fff;
  overflow: scroll;
}
.teach-left::-webkit-scrollbar {
  display: none;
}
.title {
  margin-left: 30px;
  margin-top: 29px;
  font-size: 24px;
  line-height: 1.2;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
}
.dat {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  margin-left: 30px;
  margin-top: 20px;
  margin-bottom: 19px;
}
.artic {
  width: 792px;
  height: 96px;
  margin-left: 30px;
  /* background: pink; */
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  text-indent: 2em;
  margin-bottom: 12px;
  line-height: 24px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.button {
  width: 150px;
  height: 30px;
  border: 1px solid #b78c0d;
  border-radius: 3px;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
  margin-left: 680px;
  margin-bottom: 20px;
  cursor: pointer;
}
.xian {
  width: 800px;
  height: 1px;
  background: #eeeeee;
  margin-left: 30px;
}
.teach-right {
  width: 309px;
  height: 903px;
  border-radius: 10px;
  background: #fff;
  padding-left: 30px;
  padding-right: 30px;
}
.big-title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-top: 29px;
  margin-bottom: 29px;
}
.ge {
  /* width: 250px; */
  height: 2px;
  background: #222222;
  margin-bottom: 5px;
}
.tong {
  height: 56px;
  cursor: pointer;
  /* width:250px; */
  /* background: pink; */
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  border-bottom: 1px solid #eeeeee;
  line-height: 56px;
  cursor: pointer;
}
.chang {
  color: #b78c0d;
}
.sma-title {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #222222;
  margin-top: 79px;
  margin-bottom: 29px;
}
.ope {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  margin-top: 19px;
}
.right-pub {
  margin-top: 19px;
  /* width: 250px;
 height: 145px; */
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 25px;
}
.adr-tit {
  margin: 20px 0;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
}
.right-img {
  /* width: 250px; */
  height: 103px;
  background: chocolate;
}
.order {
  /* width: 250px; */
  height: 40px;
  border: 1px solid #b78c0d;
  border-radius: 4px;
  background: #fff;
  color: #b78c0d;
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.load {
  display: flex;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  transition: all 2s;
}
::v-deep .ant-spin-dot-item {
  background-color: #b78c0d;
  /* color: #b78c0d; */
}
.load-text {
  margin-left: 10px;
  font-size: 14px;
}
</style>
